import React, { useState } from "react";
// import Img
import img from "../../assets/img/common/query_banner.png";
import SectionHeading from "../Common/SectionHeading";

const InquiryForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});

    // Get form data
    const formData = new FormData(e.target);
    const formValues = Object.fromEntries(formData.entries());

    try {
      const response = await fetch(
        "https://email-nodejs-fawn.vercel.app/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            emailConfig: {
              host: "mail.nascentinnovations.com",
              port: 465,
              user: "zainali@nascentinnovations.com",
              pass: "zainali786",
              from: "zainali@nascentinnovations.com",
            },
            emailData: {
              to: "herezainali@gmail.com", // You may want to change this or make it configurable
              subject: "New Travel Inquiry",
              text: `New inquiry from ${formValues.name}`,
              html: `
              <h2>New Travel Inquiry</h2>
              <p><strong>Name:</strong> ${formValues.name}</p>
              <p><strong>Phone:</strong> ${formValues.phone}</p>
              <p><strong>Email:</strong> ${
                formValues.email || "Not provided"
              }</p>
              <p><strong>City:</strong> ${formValues.city || "Not provided"}</p>
              <p><strong>Service:</strong> ${formValues.service}</p>
              <p><strong>Date:</strong> ${formValues.date || "Not provided"}</p>
              <p><strong>Number of Persons:</strong> ${
                formValues.no_of_persons || "Not provided"
              }</p>
              <p><strong>Number of Children:</strong> ${
                formValues.no_of_child || "Not provided"
              }</p>
              <p><strong>Number of Infants:</strong> ${
                formValues.no_of_infant || "Not provided"
              }</p>
              <p><strong>Message:</strong> ${
                formValues.message || "Not provided"
              }</p>
            `,
            },
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      setIsSuccess(true);
      e.target.reset(); // Reset form fields
    } catch (error) {
      console.error("Error sending email:", error);
      setErrors({
        submit: "Failed to send your request. Please try again later.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section id="vendor_form_area" className="section_padding">
        <div className="container">
          {/* <SectionHeading heading="YOUR ONE-STOP TRAVEL SOLUTION" />
          <br />
          <br />
          <br /> */}
          <div className="row">
            <div className="col-lg-12">
              <div className="vendor_form_heading">
                <h2>YOUR ONE-STOP TRAVEL SOLUTION</h2>
                <p>
                  Share your travel plans with us, and let us provide you with
                  the best assistance!
                </p>
              </div>
            </div>
            <div className="col-lg-8">
              {/* <div className="vendor_form_heading">
                <h2>Book Your Travel Experience</h2>
                <p>
                  Transform your travel dreams into reality with House of
                  Polani. Whether you're planning a corporate trip, religious
                  pilgrimage, or leisure vacation, our expert team is ready to
                  assist you. Complete the form below, and we'll create a
                  personalized travel solution tailored to your needs.
                </p>
              </div> */}
              <div className="vendor_form" style={{ marginRight: "50px" }}>
                <div className="tour_booking_form_box">
                  <form onSubmit={handleSubmit} id="tour_bookking_form_item">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control bg_input"
                            placeholder="Full Name*"
                            name="name"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="tel"
                            className="form-control bg_input"
                            placeholder="Phone Number*"
                            name="phone"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control bg_input"
                            placeholder="Email Address"
                            name="email"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control bg_input"
                            placeholder="Current City"
                            name="city"
                          />
                        </div>
                      </div>
                      {/*  */}
                      {/*  */}
                      {/* <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control bg_input"
                            placeholder="Destination Country"
                          />
                        </div>
                      </div> */}
                      <div className="col-lg-6">
                        <div className="form-group">
                          <select
                            className="form-control form-select bg_input"
                            name="service"
                            required
                          >
                            <option value="" disabled selected>
                              Select Service
                            </option>
                            <option>Corporate Travel</option>
                            <option>E-Ticket Services</option>
                            <option>International Reservations</option>
                            <option>Domestic Reservations</option>
                            <option>International Rail Booking</option>
                            <option>Car Rental</option>
                            <option>Worldwide Visa</option>
                            <option>Passport Services</option>
                            <option>NADRA Services</option>
                            <option>Travel Insurance</option>
                            <option>Holiday Packages</option>
                            <option>Cruise Packages</option>
                            <option>MICE Group Tours</option>
                            <option>Hajj Services</option>
                            <option>Umrah Services</option>
                            <option>Ziarat Services</option>
                            <option>Other</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="date"
                            className="form-control bg_input"
                            placeholder="Date"
                            name="date"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <input
                            type="number"
                            className="form-control bg_input"
                            placeholder="No. Of Persons"
                            name="no_of_persons"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <input
                            type="number"
                            className="form-control bg_input"
                            placeholder="No. Of Child (Age: 2-12)"
                            name="no_of_child"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <input
                            type="number"
                            className="form-control bg_input"
                            placeholder="No. Of Infant (Under 2 Years)"
                            name="no_of_infant"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            rows={5}
                            className="form-control bg_input"
                            placeholder="Message"
                            name="message"
                          />
                        </div>
                      </div>
                      {/* <div className="col-lg-6">
                        <div className="form-group">
                          <select className="form-control form-select bg_input">
                            <option disabled selected>
                              {" "}
                              Previous Travel History
                            </option>
                            <option>Yes</option>
                            <option>No</option>
                          </select>
                        </div>
                      </div> */}
                      {/* <div className="col-lg-6">
                        <div className="form-group">
                          <select className="form-control form-select bg_input">
                            <option>Country</option>
                            <option>New York</option>
                            <option>Barisal</option>
                            <option>Nator</option>
                            <option>Joybangla</option>
                          </select>
                        </div>
                      </div> */}
                    </div>
                    <div className="booking_tour_form_submit pt-4">
                      {/* <div className="form-check write_spical_check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="flexCheckDefaultf1"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefaultf1"
                        >
                          I have read and accept the{" "}
                          <a href="terms-service.html">Terms and conditions</a> and{" "}
                          <a href="privacy-policy.html">Privacy policy</a>
                        </label>
                      </div> */}
                      {errors.submit && (
                        <div className="col-lg-12">
                          <div className="alert alert-danger" role="alert">
                            {errors.submit}
                          </div>
                        </div>
                      )}

                      {isSuccess && (
                        <div className="col-lg-12">
                          <div className="alert alert-success" role="alert">
                            <h4 className="alert-heading">Thank You!</h4>
                            <p>
                              We've received your booking request. Our team will
                              contact you shortly to discuss your travel plans
                              and create a personalized solution for you.
                            </p>
                          </div>
                        </div>
                      )}

                      <button
                        type="submit"
                        className="btn btn_theme btn_md"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="vendor_img">
                <img src={img} alt="img" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InquiryForm;
